import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { interval, Observable, Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { CalRunIdModel } from '../../models/config/calrunid.model';
import { Router } from '@angular/router';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { FormControl, NgForm } from '@angular/forms';
import { CalRunIdService } from 'src/app/service/calrunid.service';
import { startWith, map } from 'rxjs/operators';
import { DatePipe, formatDate } from '@angular/common';
import { OnlineCalcService } from 'src/app/service/onlinecalc.service';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';

@Component({
  selector: 'app-calcstatus',
  templateUrl: './calcstatus.component.html',
  styleUrls: ['./calcstatus.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CalcstatusComponent implements OnInit {
  mySubscription: Subscription;

  fileLink: any;
  uid: any;
  calid: any;
  complanid: any;

  ordersTableColumns: TableColumn[];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'CalendarData';
  columnsData: any;
  checked: boolean = false;
  actionButtons: any;
  actions: any;

  selctedValues: CalRunIdModel[] = [];
  isChecked: boolean = false;

  public calcData: CalRunIdModel[] = [];
  public filterData: CalRunIdModel[] = [];

  userIdsData: CalRunIdModel[] = [];
  runCtrlIdsData: CalRunIdModel[] = [];
  filteredUserIdsData: CalRunIdModel[] = [];
  filteredRunCtrlIdsData: CalRunIdModel[] = [];
  filteredUserIdsValues: Observable<CalRunIdModel[]> | undefined;
  filteredRunCtrlIdsValues: Observable<CalRunIdModel[]> | undefined;
  controlUserId = new FormControl();
  controlRunCtrlName = new FormControl();
  selectedUserId: string = "";
  selectedRunCtrlId: string = "";


  public calendarModel = new CalRunIdModel('', 0, '', '', '', null, '', null, '', false, '', null, null, '', '', '', '', 0, 0);


  constructor(private datePipe: DatePipe, private httpService: HttpClient, private router: Router, private onlineCalcService: OnlineCalcService, private calendarService: CalRunIdService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService) {
    //this.callLoop();
  }

  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public checkedactive: boolean = false;
  public isTableExpanded = false;
  public showLoading: boolean;
  public fname: string;

  selctedCals: CalRunIdModel[] = [];
  calData: CalRunIdModel[] = [];
  excelCalData: CalRunIdModel[] = [];

  public displayedColumns = ['id', 'calendar_type', 'created_dt', 'updated_dt', 'updated_by'];
  public dataSource = new MatTableDataSource<CalRunIdModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  userId: string = "";
  runCtrlId: number = 0;

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  content: any;

  ngOnInit() {
    this.calendarModel.startTime = new Date().toISOString().substring(0, 10); // Formats to YYYY-MM-DD
    this.calendarModel.endTime = new Date().toISOString().substring(0, 10); // Formats to YYYY-MM-DD
    this.getData();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.userIds();
    this.runCtrlIds();
  }



  getData() {
    console.log("getData() called");
    this.calData = [];
    if (this.calendarModel.userId === "") {
      this.userId = "0";
    } else {
      this.userId = this.calendarModel.userId;
    }
    if (this.calendarModel.runCtrlId.toString() === "") {
      this.runCtrlId = 0;
    } else {
      this.runCtrlId = this.calendarModel.runCtrlId;
    }
    if (this.calendarModel.startTime === null || this.calendarModel.startTime.toString() === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select start date');
    } else if (this.calendarModel.endTime === null || this.calendarModel.endTime.toString() === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select end date');
    } else {
      let st = formatDate(this.calendarModel.startTime, 'yyyy-MM-dd', 'en_US');
      let et = formatDate(this.calendarModel.endTime, 'yyyy-MM-dd', 'en_US');
      //console.log(st);
      //console.log(et);
      this.calData = [];
      this.calendarService.getProcessStatus(this.userId, this.runCtrlId, st, et).subscribe(
        (response: CalRunIdModel[]) => {
          this.calData = response;
         // console.log("this.calcData = " + JSON.stringify(this.calcData));
          this.excelCalData = JSON.parse(JSON.stringify(response));
          //this.getProcessStatus();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.calrunstatus;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log(this.excelCalData)
    for (let js of this.excelCalData) {
      delete js.id;
      delete js.active_flag;
      delete js.created_dt;
      delete js.created_by;
      delete js.editMode;
      delete js.comment;
      delete js.description;
      delete js.run_status;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.runCtrlId;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelCalData.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'Cal Run Status',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.stopPolling();
  }

  ExportTOExcel() {
    this.ete.exportFromHtmlTable(this.table.nativeElement, 'CalendarData');
  }

  public runCtrlIds(): void {
    this.calendarService.getRunCtrlIds().subscribe(
      (response: CalRunIdModel[]) => {
        this.runCtrlIdsData = response;
        //console.log("this.runCtrlIdsData = " + JSON.stringify(this.runCtrlIdsData));
        this.filteredRunCtrlIdsData = this.runCtrlIdsData.filter((v, i) => this.runCtrlIdsData.findIndex(item => item.runControlName != "" && item.runControlName == v.runControlName) === i);
        this.filteredRunCtrlIdsData = this.filteredRunCtrlIdsData.sort((a, b) => (a.runControlName < b.runControlName) ? -1 : 1);
        //console.log("this.filteredSalesChannelsData = "+JSON.stringify(this.filteredSalesChannelsData));
        this.filterRunCtrlIds();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  filterRunCtrlIds() {
    this.filteredRunCtrlIdsValues = this.controlRunCtrlName.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRunCtrlId(value))
    );
  }
  private _filterRunCtrlId(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredRunCtrlIdsData.filter(item => this._normalizeValue(item.runControlName).includes(filterValue));
  }
  public getRunCtrlIds(event: any) {
    console.log("Selected Run Ids : " + event.option.value);
    this.selectedRunCtrlId = event.option.value;
  }
  public getSelectedRunCtrlIds(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredRunCtrlIdsData.find(item => item.runCtrlId === val).runControlName;
    }
    return cpdata;
  }


  public userIds(): void {
    this.calendarService.getUserIds().subscribe(
      (response: CalRunIdModel[]) => {
        this.userIdsData = response;
        //console.log("this.userIdsData = " + JSON.stringify(this.userIdsData));
        this.filteredUserIdsData = this.userIdsData.filter((v, i) => this.userIdsData.findIndex(item => item.userId != "" && item.userId == v.userId) === i);
        this.filteredUserIdsData = this.filteredUserIdsData.sort((a, b) => (a.userId < b.userId) ? -1 : 1);
        //console.log("this.filteredSalesChannelsData = "+JSON.stringify(this.filteredSalesChannelsData));
        this.filterUserIds();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  filterUserIds() {
    this.filteredUserIdsValues = this.controlUserId.valueChanges.pipe(
      startWith(''),
      map(value => this._filterUserId(value))
    );
  }
  private _filterUserId(value: string) {
    const filterValue = this._normalizeValue(value);
    return this.filteredUserIdsData.filter(item => this._normalizeValue(item.userId).includes(filterValue));
  }
  public getUserIds(event: any) {
    console.log("Selected User Ids : " + event.option.value);
    this.selectedUserId = event.option.value;
  }
  public getSelectedUserIds(val: any) {
    var cpdata = "";
    if (val === 0 || val === "" || val === null || val === undefined) {
      cpdata = "";
    } else {
      cpdata = this.filteredUserIdsData.find(item => item.userId === val).userId;
    }
    return cpdata;
  }




  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

  public getFileName(response: HttpResponse<Blob>) {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get('content-disposition');
      const r = /(?:filename=")(.+)(?:")/
      filename = r.exec(contentDisposition)[1];
    }
    catch (e) {
      filename = 'logfile.txt'
    }
    return filename
  }

 

  public downloadLogFile(uid: string, calRunId: number, comm_plan_id: number) {
    // HOA-8442: engine calls for log download are handled server-side by the Java proxy.
    this.calendarService.downloadLogFile(uid, calRunId, comm_plan_id)
      .subscribe((response: any) => {
        //console.log(response);
        let filename: string = this.getFileName(response);
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();

        this.getTextFile(downloadLink.href);
      }, (errorResponse: HttpErrorResponse) => {
        console.log(errorResponse);
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public viewLogFile(uid: string, calRunId: number, comm_plan_id: number) {
    // HOA-8442: engine calls for log download are handled server-side by the Java proxy.
    this.calendarService.downloadLogFile(uid, calRunId, comm_plan_id)
      .subscribe((response: any) => {
        //console.log(response);
        let filename: string = this.getFileName(response);
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        this.fileLink = downloadLink.href;
        //console.log("this.fileLink = " + this.fileLink);

        this.getTextFile(this.fileLink);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getTextFile(link: string) {
    //this.content = null;
    this.httpService.get(link, { responseType: 'text' })
      .subscribe((content: string) => {
        this.content = content;
        //console.log("Content: " + this.content);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  callLoop() {
    // Avoid stacking multiple intervals if the log is opened more than once.
    this.stopPolling();
    this.mySubscription = interval(5000).subscribe((x => {
      this.viewLogFile(this.uid, this.calid, this.complanid);
    }));
  }

  public refreshData(loadForm: NgForm): void {
    this.content = null;
    //console.log("refreshData called" + this.fileLink);
    //this.getTextFile(this.fileLink);
    this.viewLogFile(this.uid, this.calid, this.complanid);
  }

  public suspendRun(id: number): void {
    console.log(id);
    if (confirm("Do you want to suspend this process?")) {
      this.subscriptions.push(
        this.calendarService.suspendRun(id).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.getData();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
      );
    }
  }

  innerRowAction1(row: any) {
    this.uid = row.row.uid;
    this.calid = row.row.calRunId;
    this.complanid = row.row.comm_plan_id;

    if (row.value === 'Download') {
      this.downloadLogFile(row.row.uid, row.row.calRunId, row.row.comm_plan_id);
    } else if (row.value === 'ViewLog') {
      this.callLoop();
      this.clickButton('view');
    }else if (row.value === 'Suspend') {
      this.suspendRun(row.row.id);
    }
  }

  public clickToCloseButton(buttonId: string, kpiForm: NgForm): void {
    this.stopPolling();
    document.getElementById(buttonId).click();
  }

  /** Safely stops the LIVE log polling loop so it does not keep running in the background. */
  private stopPolling(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
      this.mySubscription = null;
    }
  }

  

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.Calcstatus;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Download',
        dataKey: 'fas fa-download success f-25',
        position: 'center',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'ViewLog',
        dataKey: 'fas fa-eye success f-25',
        position: 'center',
        isSortable: false,
        class: 'badge bg-danger'
      }
      // ,
      // {
      //   name: 'Suspend',
      //   dataKey: 'fas fa-trash-alt danger f-25',
      //   position: 'left',
      //   isSortable: false,
      //   class: 'badge bg-danger'
      // }
    ]
  }

}